import initialState from './initialState';
import produce from 'immer';

export default (state = initialState.score, action) => {
	//
	switch (action.type) {
		case 'RESET_WHOLE_STATE':
			return initialState.score;
		//
		case 'SET_ROUNDS_TO_WIN':
			return produce(state, (draft) => {
				draft.roundsToWin = action.value;
			});

		// case 'UPDATE_CURRENT_ROUND_POINTS':
		// 	return produce(state, (draft) => {
		// 		draft.value = action.value;
		// 	});

		case 'UPDATE_ROUNDS_SCORE':
			return produce(state, (draft) => {
				draft.ourRounds = action.ourRounds;
				draft.opponentRounds = action.opponentRounds;
			});

		case 'UPDATE_HAND_POINTS':
			return produce(state, (draft) => {
				draft.ourPoints = action.ourPoints;
				draft.opponentPoints = action.opponentPoints;
			});

		case 'RESET_SCORE':
			return produce(state, (draft) => {
				draft.ourRounds = 0;
				draft.opponentRounds = 0;
				draft.ourPoints = 0;
				draft.opponentPoints = 0;
			});
		default:
			return state;
	}
};
